import React from "react";
import vhCheck from "vh-check";
import TalentApplication from "../../TalentApplication";
import stateChart from "../stateChart";
import StateMachine from "../../utils/StateMachine";
import { Router, Route, Switch, Redirect } from "react-router-dom";
import { createBrowserHistory } from "history";
import asyncComponent from "../../../utils/asyncComponent.js";
import WebLogin from "../../Home/Login/web-login";
import Instructions from "../../TalentApplication/Instructions";
import AboutUsClub from "../../AboutUs/AboutUsClub";
import SessionTransfer from "../../Account/SessionTransfer";
import PaymentSuccess from "../../Payment/PaymentSuccess";
import PaymentCancelled from "../../Payment/PaymentCancelled";
import MembershipTerms from "../../Payment/MembershipTerms";

// Sets css variable --vh-offset
vhCheck();

const Contact = asyncComponent(() =>
  import("../../Register/ContactUs")
);
const TermsOfUse = asyncComponent(() =>
  import("../../LegalAgreements/TermsOfUse")
);

const CookiePolicy = asyncComponent(() =>
  import("../../LegalAgreements/CookiePolicy")
);

const PrivacyPolicy = asyncComponent(() =>
  import("../../LegalAgreements/PrivacyPolicy")
);

const Support = asyncComponent(() =>
  import("../../Support")
);

const Admin = asyncComponent(() => import("../../Admin"));

// Stamp an idx into each history entry's state; the legal-modal X shows only when idx > 0 (a real previous page).
const clubHistory = createBrowserHistory();
const withIdx = (path, state, idx) =>
  path && typeof path === "object"
    ? [{ ...path, state: { ...path.state, idx } }]
    : [path, { ...state, idx }];
const originalPush = clubHistory.push.bind(clubHistory);
const originalReplace = clubHistory.replace.bind(clubHistory);
clubHistory.push = (path, state) =>
  originalPush(...withIdx(path, state, (clubHistory.location.state?.idx ?? 0) + 1));
clubHistory.replace = (path, state) =>
  originalReplace(...withIdx(path, state, clubHistory.location.state?.idx ?? 0));

export default function ClubRoutes() {
    return (
        <Router history={clubHistory}>
            <StateMachine machine={stateChart}>
                <Switch>
                    <Route exact path="/aboutus" component={AboutUsClub} />
                    <Route exact path="/session-transfer" component={SessionTransfer} />
                    <Route exact path="/memberships" component={Instructions} />
                    <Route exact path="/login" component={WebLogin} />
                    <Route exact path="/membership/terms/:token" component={MembershipTerms} />
                    <Route exact path="/membership/payment-success" component={PaymentSuccess} />
                    <Route exact path="/membership/payment-cancelled" component={PaymentCancelled} />
                    <Route path="/apply" component={TalentApplication} />
                    {/*Temporary route to clear localStorage and redirect to signup*/}
                    <Route exact path="/reset" render={() => {
                        localStorage.clear();
                        return <Redirect to="/apply" />;
                    }} />
                    <Route path="/admin" component={Admin} />
                    <Route path="/terms-of-use" component={TermsOfUse} />
                    <Route path="/contact-us" component={Contact} />
                    <Route path="/cookie-policy" component={CookiePolicy} />
                    <Route path="/privacy-policy" component={PrivacyPolicy} />
                    <Route path="/support" component={Support} />
                    <Redirect from="/terms-and-conditions" to="/terms-of-use" />
                    <Redirect from="/privacy-notice" to="/privacy-policy" />
                    <Redirect from="/cookie-statement" to="/cookie-policy" />
                    <Redirect to="/aboutus" />
                </Switch>
            </StateMachine>
        </Router>
    );
}
